import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CommonButton from "components/commonButton/CommonButton";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";

const vehicleColumns = [
  { id: "model", label: "Model" },
  { id: "vehicleNo", label: "Vehicle No." },
  { id: "vehicleGroup", label: "Vehicle Group" },
  { id: "driver", label: "Driver" },
  { id: "availability", label: "Availability" },
  { id: "action", label: "" },
];

const supplierColumns = [
  { id: "subVendorName", label: "Sub Vendor  Name" },
  { id: "cityName", label: "City" },
  // { id: "availableVehicles", label: "Available Vehicles" },
  { id: "action", label: "" },
];

const AllotingVehicleTable = ({ myvehicleList, handleAllot, tab }) => {
  const isSupplier = tab === "mySuppliers";
  const columns = isSupplier ? supplierColumns : vehicleColumns;

  const renderVehicleCell = (data, columnId) => {
    switch (columnId) {
      case "model":
        return data?.Vehicle?.carModel || "NA";
      case "vehicleNo":
        return data?.Vehicle?.regNumber || "NA";
      case "vehicleGroup":
        return data?.Vehicle?.MasterCarType?.carType || "NA";
      case "driver":
        return data?.driverName || "NA";
      case "availability":
        return (
          <Typography
            className={data?.isOnDuty ? "colorGreen" : "colorRed"}
            variant="caption"
            sx={{ fontSize: "14px" }}
          >
            {data?.isOnDuty ? "On Duty" : "Off Duty"}
          </Typography>
        );
      default:
        return "NA";
    }
  };

  const renderSupplierCell = (data, columnId) => {
    switch (columnId) {
      case "subVendorName":
        return data?.subVendorName || "NA";
      case "cityName":
        return data?.cityName || "NA";
      case "availableVehicles":
        return data?.availableVehicles ?? data?.vehicleCount ?? "NA";
      default:
        return "NA";
    }
  };

  return (
    <TableContainer>
      {myvehicleList?.length ? (
        <Table aria-label="simple table" className="allridesTableMain">
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell key={col.id}>{col.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {myvehicleList?.map((data, index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                {columns.map((col) =>
                  col.id === "action" ? (
                    <TableCell key={col.id}>
                      <CommonButton
                        name="Allot"
                        btnClass={"btnXtraSmall btnBlue"}
                        onClick={() => handleAllot(data)}
                      />
                    </TableCell>
                  ) : (
                    <TableCell key={col.id}>
                      {isSupplier
                        ? renderSupplierCell(data, col.id)
                        : renderVehicleCell(data, col.id)}
                    </TableCell>
                  ),
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Box>
          <CommonNoDataFound />
        </Box>
      )}
    </TableContainer>
  );
};

export default AllotingVehicleTable;
